<template>
  <div class="attachment-container">
    <!--动作组-->
    <el-row>
      <el-col :span="12">
        <el-tabs v-model="listQuery.type" type="card">
          <el-tab-pane v-if="fileType === 'image' || fileType === 'img_video'" name="image"><span slot="label"><i class="el-icon-picture"></i> 图片</span></el-tab-pane>
          <el-tab-pane v-if="fileType === 'audio'" name="audio"><span slot="label"><i class="el-icon-microphone"></i>音频</span></el-tab-pane>
          <el-tab-pane v-if="fileType === 'video' || fileType === 'img_video'" name="video"><span slot="label"><i class="el-icon-video-play"></i>视频</span></el-tab-pane>
          <el-tab-pane v-if="fileType === 'document'" name="document"><span slot="label"><i class="el-icon-document"></i>文档</span></el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="12" class="right-btn">
        <span>还可以选择：{{ canSelect }} 项</span>
        <el-upload
          ref="elupload"
          style="display: inline-block;"
          :action="listQuery.group_id !== null?upload_url+'?group_id='+ listQuery.group_id:upload_url"
          multiple
          :auto-upload="true"
          :show-file-list="false"
          :headers="requestHeaders"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <el-button size="mini" type="primary" icon="el-icon-plus">上传资源</el-button>
        </el-upload>
      </el-col>
    </el-row>
    <el-row style="background: #F7F8F9;">
      <el-col :span="4">
        <AttachmentGroup :type="listQuery.type" @change="groupChange" />
      </el-col>
      <el-col :span="20" style="height:512px;background: #FFF;">
        <div v-loading="listLoading" class="list-container">
          <div v-for="o in list" :key="o.id" class="list-item" :style="{'width': o.type=='audio' ? '236px' : '150px'}" :class="{'active':o.isChecked}" @click.stop="itemisChecked(o)">
            <!-- 图片 -->
            <div v-if="o.type=='image'" class="img_box" :style="{background:'url('+o.save_path+'!size=150X150)'}"></div>
            <!-- 视频 -->
            <div v-if="o.type=='video'" class="video_box">
              <video :src="o.save_path" width="150" height="100" controls="controls"></video>
            </div>
            <!-- 音频 -->
            <div v-if="o.type=='audio'">
              <audio :src="o.save_path" controls style=" width: 100%;hight:40px"></audio>
            </div>
            <!-- 文档 -->
            <div v-if="o.type === 'document'" :class="'image-' + o.extension_name.slice(1)" fit="cover" style="width:130px;height:150px;"></div>
            <div class="actions">
              {{ o.original_name }}
            </div>
          </div>
        </div>
        <!--分页-->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :page-sizes="[12, 20, 50, 100]" :limit.sync="listQuery.limit" @pagination="loadData"></pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '@/api/attachment'
import { getToken } from '@/utils/auth'
import commonList from '@/utils/commonList'
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import AttachmentGroup from './AttachmentGroup'

export default {
  name: 'AttachmentSelect',
  components: { Pagination, AttachmentGroup },
  mixins: [commonList],
  props: {
    limit: {
      type: Number,
      default: 10
    },
    fileType: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      upload_url: process.env.VUE_APP_BASE_API + 'admin/Resources/Upload',
      requestHeaders: {
        'Authorization': 'Bearer ' + getToken()
      },
      // api接口方法
      api,
      // 额外过滤条件
      listQuery: {
        limit: 12,
        group_id: null,
        type: 'image'
      }
    }
  },
  computed: {
    canSelect() {
      return this.limit - this.getSelectItems().length
    }
  },
  created() {
    this.listQuery.type = this.fileType === 'img_video' ? 'image' : this.fileType
  },
  mounted() {
    console.log('this.fileType', this.fileType)
    console.log(this.listQuery.type)
    console.log(this.listQuery.type)
  },
  methods: {
    itemisChecked(o) {
      if (o.isChecked === true) {
        o.isChecked = false
      } else if (this.canSelect > 0) {
        o.isChecked = true
      } else {
        // 移除最前面的对象
        const sitem = this.getSelectItems()
        if (sitem.length > 0) {
          sitem[0].isChecked = false
          o.isChecked = true
        }
      }
    },
    afterLoadData(list) {
      list.forEach(re => { re.isChecked = false })
      return list
    },
    groupChange(group, list) {
      this.listQuery.group_id = group.id
      this.loadData()
    },
    getSelectItems() {
      const selectItem = []
      this.list.forEach(ele => {
        if (ele.isChecked) { selectItem.push(ele) }
      })
      return selectItem
    },
    clearSelectItems() {
      this.list.forEach(ele => {
        ele.isChecked = false
      })
    },
    getSelectIds() {
      const selectIds = []
      this.list.forEach(ele => {
        if (ele.isChecked) { selectIds.push(ele.id) }
      })
      return selectIds
    },
    // 文件上传
    uploadSuccess(response, file, fileList) { // 新文件上传成功后重新加载列表
      if (response.code !== 20000) {
        this.$message.error(response.msg)
        return false
      }
      this.loadData()
    },
    uploadError() {
      this.$message.error('上传错误')
    }
  }
}
</script>
<style lang="scss" scoped>
.attachment-container{
  .pagination-container{
    padding: 10px;
  }
  .right-btn{
    text-align: right;
    min-height: 41px;
    border-bottom: 1px solid #dfe4ed;
  }
}
.list-container{
  overflow: hidden;
  height: 460px;

  .list-item{
    padding: 0 5px;
    display: inline-block;
    width: 150px;
    box-sizing: content-box;
    margin: 0 5px 5px 5px;
    border: 2px solid #F7F8F9;
    background-color:#F7F8F9 ;
    cursor: pointer;
    //  .el-image{
    //     border: 2px solid #fff;
    //   }
    .img_box{
      background-size: cover;
      width:150px;height:120px;
      background-repeat: no-repeat;
    }
    .video_box{
      overflow: hidden;
      width:150px;height:100px;
    }
    .image-pdf{
      background-image: url(/pdf.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-docx{
      background-image: url(/docx.png);
      background-size: cover;
      background-position: center center;
    }
    .image-xlsx{
      background-image: url(/xlsx.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-zip{
      background-image: url(/zip.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-rar{
      background-image: url(/rar.jpg);
      background-size: cover;
      background-position: center center;
    }
    &.active{
      border: 2px solid #07d;
    }
  }
  .el-col{
    padding-bottom: 20px;
  }
  .actions{
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    overflow: hidden; color: #a9a9a9;
  }

}

</style>
